const cratifyContactCardCode = '<div class="crtf-contact-card"><h4>Potrebujete poradiť?</h4><div class="crtf-contact-card__person"><div class="crtf-contact-card__photo"><img src="/user/documents/upload/images/avatar-min.jpg" alt="Fotografia zákazníckej linky"></div><div class="crtf-contact-card__person-info"><div class="crtf-contact-card__name">Mgr. Dominka Vlach</div><div class="crtf-contact-card__position">Majiteľka e-shopu</div></div></div><div class="crtf-contact-card__contacts"><div class="crtf-contact-card__contact crtf-contact-card__email"><a href="mailto:info@materialyoddomci.cz">info@materialyoddomci.cz</a></div></div>';

/*Preparing*/

$('.availability-label').prepend('<span class="availability-label__indicator"></span>').append('&nbsp;|<a href="/jak-nakupovat/">Viac informácií</a>');
$('.search-input').attr('placeholder', creatifySettings.search.placeholder);
$('.blog-wrapper .homepage-group-title').text(creatifySettings.blog.title);

/*Blog*/
if(document.body.classList.contains('type-post')) {
  const postImage = $('#content > div > div > span:nth-child(5) > meta:nth-child(1)').attr('content');
  if(postImage) {
    $('.news-item-detail').prepend('<img src="' + postImage + '" class="post-image" />');
  }
}
const homepageBlogWrapper = $('.homepage-blog-wrapper');
if(homepageBlogWrapper.length > 0) {
  homepageBlogWrapper.append($('<div class="news-wrapper">').append($('.news-item')));  
}

/* Sidebar contact card */
$('.type-post .content-wrapper-in, .type-page .content-wrapper-in').append(cratifyContactCardCode);
$('.type-product #tab-content').append(cratifyContactCardCode);

if(creatifySettings.topMessage.active) {
  $("#header").before('<div class="crtf-top-message crtf-top-message--' + creatifySettings.topMessage.variant + '">' + creatifySettings.topMessage.content + '</div>');
}

$(".p-detail-tabs-wrapper").after($('<div class="container">').prepend($('<div class="row">').load("/ .crtf-about-us-banners")));

/* Show body after everything prepared */
$("body").fadeTo(0, 1);